import type { UseModule } from '~/types'
import { createPinia } from 'pinia'

export const pinia = createPinia()
export const install: UseModule = ({ instance }) => {
  instance.use(pinia)
}
